import { useCallback, useState } from 'react';

// useState that survives leaving the page and coming back (and a refresh),
// but not closing the tab: list filters, search terms, the page you were on.
// Per browser tab, so two tabs don't fight over the same filters.
export default function useSessionState(key, initialState) {
  const [state, setState] = useState(() => {
    try {
      const raw = sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : initialState;
    } catch {
      return initialState; // private mode / blocked storage: behaves as useState
    }
  });

  const setAndStore = useCallback(
    value => {
      setState(prev => {
        const next = typeof value === 'function' ? value(prev) : value;
        try {
          if (next === undefined || next === null) {
            sessionStorage.removeItem(key);
          } else {
            sessionStorage.setItem(key, JSON.stringify(next));
          }
        } catch {
          // storage full or blocked: the state still updates for this visit
        }
        return next;
      });
    },
    [key]
  );

  return [state, setAndStore];
}
